import { Checkbox, ListItem, ListItemAvatar, ListItemIcon, ListItemText } from "@material-ui/core";
import { MouseEventHandler } from "react";
import { BeerImage, BeerItemPropertyDescription, BeerItemPropertyTitle, BeerName } from './beer-list-item.styles';
import { Beer } from "store/reducers/beers/reducer";

function beerHasInfo(beer: Beer | string | null): boolean {
    if (typeof beer === 'string' || !beer) {
        return false;
    }
    return beer?.mouthfeel?.length > 0;
};

export type BeerListItemProps = {
    beer: Beer | string | null,
    onClick?: MouseEventHandler<HTMLDivElement>,
    preSelectedIndex?: number,
    selected?: boolean,
    selectable?: boolean
}

const BeerListItem = ({
    beer,
    onClick,
    preSelectedIndex = -1,
    selected = false,
    selectable = true,
}: BeerListItemProps) => {
    const ItemComponent = (p: any) => (
        selectable ? <ListItem {...p} button /> : <ListItem {...p} />
    );
    return (
        <ItemComponent
            onClick={onClick}
            divider
        >
            {selectable &&
                <ListItemIcon>
                    <Checkbox
                        edge="start"
                        checked={selected}
                        tabIndex={-1}
                        disableRipple
                    />
                </ListItemIcon>
            }
            {beerHasInfo(beer) ?
                <>
                    <ListItemAvatar>
                        <BeerImage beer={beer} />
                    </ListItemAvatar>
                    <ListItemText primary={(beer as Beer).displayName} secondary={
                        <>
                            <BeerItemPropertyTitle>Appearance</BeerItemPropertyTitle>
                            <BeerItemPropertyDescription>{(beer as Beer).appearance}</BeerItemPropertyDescription>
                            <BeerItemPropertyTitle>Smell</BeerItemPropertyTitle>
                            <BeerItemPropertyDescription>{(beer as Beer).smell}</BeerItemPropertyDescription>
                            <BeerItemPropertyTitle>Taste</BeerItemPropertyTitle>
                            <BeerItemPropertyDescription>{(beer as Beer).taste}</BeerItemPropertyDescription>
                            <BeerItemPropertyTitle>Mouthfeel</BeerItemPropertyTitle>
                            <BeerItemPropertyDescription>{(beer as Beer).mouthfeel}</BeerItemPropertyDescription>
                        </>
                    } />
                </>
                : <BeerName preSelectedIndex={preSelectedIndex}>
                    {(beer as Beer).displayName ?? (beer as string | null)}
                </BeerName>
            }
        </ItemComponent>
    )
};
export default BeerListItem;